import './dropdown.less'

import {m} from '@codeurs/front'
import {ArrowIcon, ArrowIconDropdown} from 'assets/inline-icons'
import React, {Fragment, useEffect, useState} from 'react'
import {style} from '../../util/style'

const styles = style('dropdown', ['items', 'item'])
export type DropdownType = {
	title: string
}

export const Dropdown: React.FC<DropdownType> = ({title, children}) => {
	const [isOpen, setOpen] = useState(false)
	useEffect(() => setOpen(false), [title])
	return (
		<Fragment>
			<div
				class={styles('overlay').is({open: isOpen})}
				onClick={() => setOpen(false)}
			/>
			<div className={styles.is({open: isOpen})}>
				<div
					className={styles('title').is({open: isOpen})}
					onClick={() => setOpen(!isOpen)}
				>
					{title}
					<ArrowIcon className={styles('arrow').is({open: isOpen})} />
				</div>
				<div className={styles.items.is({open: isOpen})}>
					<div className={styles.items('content').is({open: isOpen})}>
						{children}
					</div>
				</div>
			</div>
		</Fragment>
	)
}

export const DropdownItem: React.FC = ({children}) => (
	<div class={styles.item}>{children}</div>
)
